// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModelManagement_main__Raf93 {
    width: 100%;
    height: 100%;
}

.ModelManagement_header__932Xp {
    height: 35px;
    margin-bottom: 25px;
}

.ModelManagement_title__u38J5 {
    font-size: 30px;
}

.ModelManagement_container__sDk-w {
    display: flex;
    width: 100%;
    min-height: calc(100% - 60px);
    border-radius: 6px;
    background-color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/ModelManagement/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;IAClB,yBAAyB;AAC7B","sourcesContent":[".main {\n    width: 100%;\n    height: 100%;\n}\n\n.header {\n    height: 35px;\n    margin-bottom: 25px;\n}\n\n.title {\n    font-size: 30px;\n}\n\n.container {\n    display: flex;\n    width: 100%;\n    min-height: calc(100% - 60px);\n    border-radius: 6px;\n    background-color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `ModelManagement_main__Raf93`,
	"header": `ModelManagement_header__932Xp`,
	"title": `ModelManagement_title__u38J5`,
	"container": `ModelManagement_container__sDk-w`
};
export default ___CSS_LOADER_EXPORT___;
